// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"1509e653","707":"3424a9dc","729":"801e6e40"}[chunkId] + ".js";
};